import { render, staticRenderFns } from "./EditionTranslations_TinyMceEditor.vue?vue&type=template&id=4e077661&scoped=true"
import script from "./EditionTranslations_TinyMceEditor.vue?vue&type=script&lang=js"
export * from "./EditionTranslations_TinyMceEditor.vue?vue&type=script&lang=js"
import style0 from "./EditionTranslations_TinyMceEditor.vue?vue&type=style&index=0&id=4e077661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e077661",
  null
  
)

export default component.exports